import { render } from "./orthopedic_prescriptions.vue?vue&type=template&id=556c457a&scoped=true"
import script from "./orthopedic_prescriptions.vue?vue&type=script&lang=js"
export * from "./orthopedic_prescriptions.vue?vue&type=script&lang=js"

import "./orthopedic_prescriptions.vue?vue&type=style&index=0&id=556c457a&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-556c457a"]])

export default __exports__